import React from "react";
import "react-toastify/dist/ReactToastify.css";
import {Modal} from 'rsuite';

import './confirmedSaveModal.scss';
import EditInfo from './../../../../img/edit-info.svg';

const ConfirmedSaveModal = ({title, handleCancel, handleSave, confirmedModal, setConfirmedModal}) => {
    return (<div>

            <Modal open={confirmedModal} onClose={closeConfirmedModal} size="xs" keyboard={true}>
                <Modal.Header>
                    <Modal.Title></Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="regime-form-modal-svg">
                        <img src={EditInfo} alt={'edit svg '}/>
                    </div>

                    <p className="regime-form-modal-content">
                        {title}
                    </p>
                </Modal.Body>
                <Modal.Footer style={{textAlign: 'center'}}>
                    <div className="modal_buttons_container">
                        <button onClick={handleCancel} className="btn-green-secondary" style={{width: "45%"}}>
                            خیر
                        </button>
                        <button onClick={handleSave} className="btn-green" style={{width: "45%"}}>
                            بله
                        </button>
                    </div>
                </Modal.Footer>
            </Modal>
        </div>
    );


    function closeConfirmedModal() {
        setConfirmedModal(false);
    }
}

export default ConfirmedSaveModal;